import { render } from "./ValidationHistoryTypesDropdownFilterContainer.vue?vue&type=template&id=0ca63a56"
import script from "./ValidationHistoryTypesDropdownFilterContainer.vue?vue&type=script&lang=js"
export * from "./ValidationHistoryTypesDropdownFilterContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__